import { INITIALIZE_FORM } from '../actionTypes';
import { chatActions } from '../reducer';

export default (values) => chatActions[INITIALIZE_FORM](values);
